// removed by extract-text-webpack-plugin
module.exports = {"container":"Popup__container___Grgnj","appear":"Popup__appear___3kQjv","header":"Popup__header___2mAjC","body":"Popup__body___1sdjm","grippy":"Popup__grippy___3e4Fx","close":"Popup__close___3mVdn","mobileView":"Popup__mobileView___vonKC"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/views/widgets/Popup.css
 ** module id = 714
 ** module chunks = 0
 **/